import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ComponentLoader } from 'cat-ecommerce-alloy';
import styles from '../myEquipmentHeader.scss';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer';

const SelectEquipmentCTA = ({
  selectedEquipment,
  myEquipmentList,
  loading,
  isPM
}) => {
  const { t } = useTranslation();
  let selectedEquipmentCTADescription;
  let selectedEquipmentCTATitle;
  const { openSelectDrawer, getDrawerComponent } = useEquipmentDrawer();
  if (isPM) {
    selectedEquipmentCTATitle = t('SELECT_EQUIPMENT');
    selectedEquipmentCTADescription = (
      <p className={`${styles['pm-kit-text']} text-lowercase`}>
        {t('PM_KIT_CTA_TAG')}
      </p>
    );
  } else {
    selectedEquipmentCTATitle = t('MEQ_SELECT_EQUIP_CTA');
    selectedEquipmentCTADescription = <p>{t('MEQ_PARTS_FIT_CTA')}</p>;
  }
  return (
    <div
      id="selectMyEquipment"
      className={`${styles['equipment-fitment__no-equipment']}`}
    >
      {loading ? (
        <ComponentLoader />
      ) : (
        <>
          <button
            type="button"
            data-testid="selectMyEquipmentBtn"
            onClick={openSelectDrawer}
          >
            {selectedEquipmentCTATitle}
          </button>
          {selectedEquipmentCTADescription}
        </>
      )}
      {getDrawerComponent({
        currentEquipment: selectedEquipment,
        myEquipmentList: myEquipmentList
      })}
    </div>
  );
};

SelectEquipmentCTA.propTypes = {
  loading: PropTypes.bool,
  selectedEquipment: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  ),
  myEquipmentList: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string]))
  ),
  isPM: PropTypes.bool
};

export default SelectEquipmentCTA;
